<div class="zoom-redirect-container">
  @if (isProcessing) {
    <div class="content">
      <h2>
        {{
          'settings.integrations.zoom.template.redirectPageProcessingTitle'
            | translate
        }}
      </h2>
      <p>
        {{
          'settings.integrations.zoom.template.redirectPageProcessingMessage'
            | translate
        }}
      </p>
    </div>
  }

  @if (error && !isProcessing) {
    <div class="content error">
      <mat-icon color="warn">error</mat-icon>
      <h2>
        {{
          'settings.integrations.zoom.template.redirectPageErrorTitle'
            | translate
        }}
      </h2>
      <p>
        {{
          'settings.integrations.zoom.template.redirectPageErrorMessage'
            | translate
        }}
      </p>
    </div>
  }
</div>
